import React, { Component } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line
} from "recharts";
const data = [
  {
    name: "Jan",
    Others: 10,
    WithBella: 1
  },
  {
    name: "Feb",
    Others: 10,
    WithBella: 2
  },
  {
    name: "March",
    Others: 11,
    WithBella: 3
  },
  {
    name: "April",
    Others: 14,
    WithBella: 3
  },
  {
    name: "May",
    Others: 15,
    WithBella: 1
  },
  {
    name: "June",
    Others: 16,
    WithBella: 2
  },
  {
    name: "July",
    Others: 18,
    WithBella: 4
  }
];

export default class ChartData extends Component {
  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <AreaChart
          width={570}
          height={180}
          data={data}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="Others"
            stackId="1"
            stroke="#8884d8"
            fill="#8884d8"
          />
          <Area
            type="monotone"
            dataKey="WithBella"
            stackId="1"
            stroke="#ffc658"
            fill="#ffc658"
          />
          <Legend verticalAlign="top" height={36} />
          <Line
            name="With others"
            type="monotone"
            dataKey="Others"
            stroke="#8884d8"
          />
          <Line
            name="With Bella"
            type="monotone"
            dataKey="Bella"
            stroke="#82ca9d"
          />
        </AreaChart>
      </div>
    );
  }
}
